import {
  IProductCityLevelPayload,
  IcreateUserPayload,
  IProductCityLevelDetailsResponse,
  IProductCityLevelInventory,
  INormalizedProductCityLevelInventory,
  IProductCityLevelInventoryPayload,
  IOdooTaxResponse,
  ISelectedBrand,
  IWarehousePayload,
  IStorageBlock,
} from "../interfaces/Index";

export const normalizeProductCityLevelUpdateReqPayload = (
  state: IProductCityLevelPayload
) => {
  let jsonData: any = {};
  jsonData.id = state.id;
  jsonData.title = state.productCityLevelTitle;
  jsonData.description = state.productCityLevelDescription;
  jsonData.variantId = state.variantId as string;
  jsonData.sku = state.productCityLevelSku;
  jsonData.tax = {
    salesTaxId: state.sellingTax && (state.sellingTax as ISelectedBrand).id,
    purchaseTaxId:
      state.purchaseTax && (state.purchaseTax as ISelectedBrand).id,
    advanceTaxApplicable: state.advanceTaxApplicable,
    furtherTaxApplicable: state.furtherTaxApplicable,
  };
  jsonData.appChannels = state.appChannels;
  jsonData.customerChannelAttributesMap = state.customerChannelAttributesMap;
  jsonData.priceRetail = state.productCityLevelRetailPrice || 0.0;
  jsonData.storageBlock =
    state.storageBlock && (state.storageBlock as IStorageBlock).value;
  return { jsonData };
};

const normalizeProductVisibility = (visibilityArray: string[]) => {
  return (visibilityArray || []).map((tag) => tag.replace("_", " "));
};

export const normalizeFetchProductCityLevelResponse = (
  res: Array<IcreateUserPayload>,
  pagination: any,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 25 ? pagination : false,
    isPaginatedRes,
  };
  const productCityLevelPayload = res.map((productCityLevel) => {
    return {
      id: productCityLevel.id,
      productCityLevelTitle: productCityLevel.title || productCityLevel.name,
      productCityLevelDescription: productCityLevel.description || "",
      productCityLevelCategories: productCityLevel.category,
      brand: productCityLevel.brand || "",
      variantId: productCityLevel.variantId,
      productCityLevelSku: productCityLevel.sku || "",
      productCityLevelOriginalPrice: productCityLevel.originalPrice || 0,
      customerChannelAttributesMap:
        productCityLevel.customerChannelAttributesMap || "",
      productCityLevelDisplayPrice: productCityLevel.displayPrice || 0,
      productCityLevelRetailPrice: productCityLevel.retailPrice || 0,
      productCityLevelStock:
        productCityLevel.availableStock || productCityLevel.stock,
      status: productCityLevel.status || "",
      productCityLevelImage: productCityLevel.imageUrl || "",
      productWeight: {
        productCityLevelWeightValue: "",
        producCityLeveltWeightUnit: "",
      },
      appChannels: productCityLevel.appChannels || [],
      uomSale: productCityLevel.uomSale || "",
      purchaseTaxId: productCityLevel.purchaseTaxId || "",
      salesTaxId: productCityLevel.salesTaxId || "",
      productCityLevelVisibility: normalizeProductVisibility(
        productCityLevel.visibility as any
      ),
    };
  });
  payload.productCityLevelData = productCityLevelPayload;
  return payload;
};

export const normalizeProductCityLevelCategories = (categories: any) => {
  return categories.map((cat: any) => {
    return {
      id: cat.id,
      title: cat.title,
      key: cat.title,
    };
  });
};

export const normalizeProductCityLevelBrand = (productCityLevelBrands: any) => {
  return productCityLevelBrands.map((type: any) => {
    return {
      id: type.id,
      value: type.id,
      label: type.value,
    };
  });
};

export const normalizeWareHouseNames = (wareHouseNames: any) => {
  return wareHouseNames.map((data: any) => {
    return {
      id: data.id,
      name: data.name,
      latitude: data.latitude,
      longitude: data.longitude,
    };
  });
};

export const normalizeProductCityLevelInventory = (
  productCityLevelInventory: IProductCityLevelInventory[]
): INormalizedProductCityLevelInventory[] => {
  return productCityLevelInventory.map((data: IProductCityLevelInventory) => {
    return {
      warehouseId: data.warehouseId,
      quantity: data.quantity,
      primeQuantity: data.primeQuantity,
    };
  });
};

export const normalizeProductCityLevelInventoryUpdateReqPayload = (
  state: IProductCityLevelInventoryPayload
) => {
  return {
    productId: state.productCityLevelId,
    inventoryDetails: state.inventoryDetails,
  };
};

export const normalizeCities = (cities: any) => {
  return cities.map((city: any) => {
    return {
      id: city.id,
      value: city.id,
      label: city.title,
    };
  });
};

export const normalizeWarehouseNameAndProductCityLevelEntry = (
  warehouseName: IWarehousePayload[],
  productCityLevelInventory: IProductCityLevelInventory[]
): IProductCityLevelInventory[] => {
  return warehouseName.map((warehouse) => {
    const entryFound = productCityLevelInventory.find(
      (warehouseProduct) => warehouseProduct.warehouseId === warehouse.id
    );

    return {
      warehouseId: entryFound ? entryFound.warehouseId : warehouse.id,
      quantity: entryFound ? entryFound.quantity : 0,
      primeQuantity: entryFound ? entryFound.primeQuantity : 0,
    };
  });
};
